<div class="flex items-center justify-center h-full" *transloco="let t">
  <div class="text-center flex flex-col gap-2">
    <img
      [src]="ASSET_CONSTANTS.I_empty_list"
      alt="empty list"
      class="w-12 h-12 mx-auto"
    />
    <span class="font-bold">{{t('nothingToShow')}}</span>
    <span class="text-mbaza-gray">{{t('thisListIsEmpty')}}</span>
  </div>
</div>
